import React, { useState } from 'react';
import Chart from "react-apexcharts";
import { useEffect } from 'react';
import { BsArrowBarRight, BsArrowBarLeft } from "react-icons/bs"

const CapacityChart = ({ chartData, showChart, mapPlacement, mapView, capacityChartConfig, iconData,isLegendMinimized }) => {

  const [expanded, setExpanded] = useState(false);
  const [iconSelection, setIconSelection] = useState(true)
  const [chartAlignment, setChartAlignment] = useState({ right: '5px' });

  const buttonIcon = iconSelection ? <BsArrowBarLeft /> : <BsArrowBarRight />;

  const [chartColors, setChartColors] = useState([])
  const [yAxisData, setYAxisData] = useState([])
  const [maxEnodValue, setMaxEnodValue] = useState(0)

  const toggleChart = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {

    if(chartData && chartData.yData && capacityChartConfig.length != 0) {
      let colorArray = []
      const yData = []

      const configContent = capacityChartConfig[0].content.find(item => item.type == "action")

      configContent.values.forEach((item) => {
        const yChartData = chartData?.yData.find(val => val.name == item.text)
        if(yChartData) yData.push(yChartData)
      })

      const remainingData = chartData?.yData.filter(val => !configContent.values.find(configVal => val.name == configVal.text))
      yData.push(...remainingData)

      const filteredYData = yData.map((item) => {
        const colorObj = configContent.values.find(val => val.text == item.name)
        if(colorObj) colorArray.push(colorObj.color)
        
        return {...item, yAxisIndex: item.type == 'line' ? 1 : 0}
      })

      setYAxisData(filteredYData)

      const barSeries = filteredYData.filter(series => series.type === "bar");
      if (barSeries.length > 0) {
        const maxValues = barSeries.map(series => Math.max(...series.data));
        setMaxEnodValue(Math.max(...maxValues));
      } 

      setChartColors(colorArray)
  }

  }, [chartData, capacityChartConfig])

  useEffect(() => {
    if (mapPlacement === 'right' && mapView) {
      setChartAlignment({ right: '8px' })
      setIconSelection(!expanded)
    }
    if (mapPlacement === 'left' && mapView) {
      setChartAlignment({ left: '8px' })
      setIconSelection(expanded)
    }
    if (mapPlacement === 'left' && (!mapView)) {
      setChartAlignment({ right: '8px' })
      setIconSelection(!expanded)
    }
  }, [mapView, expanded])

  const getMaxSector = () => {
    const yData = chartData?.yData?.find(x => x.type === 'line');
    if (yData && yData.data) {
      const maxValue = Math.max(...yData.data);
      return maxValue > 1000 ? Math.ceil(maxValue / 1000) * 1000 : Math.ceil(maxValue / 10) * 10 ;
    }
    return 3000;
  }

  const ChartObj = {
    options: {
      colors: [...chartColors,'#0000FF','#FFA500'],
      title: {
        text: 'Count of EnodeB by Action / Count of Sector',
        align: 'left',
        style: {
          fontSize: '14px',
          color: '#333',
        },
      },
      chart: {
        id: "myChart",
        fontFamily: 'Open Sans', 
        foreColor: '#808080', 
        fontWeight: 600,
      },
      legend: {
        fontSize: '12px',
        fontWeight: 600,
        markers: {
          shape: 'circle',
        },
      },
      toolbar: {
        show: false,
      },
      stroke: {
        width: [1, 1, 1], 
      },
      plotOptions: {
        bar: {
          columnWidth: '90%',
          dataLabels: {
            position: 'bottom'
          } 
        },
      },
      xaxis: {
        categories: chartData.xData,
        labels: {
          style: {
            fontSize: '10px',
          },
        },
      },
      yaxis: [
        {
          title: {
            text: 'Count of EnodeB',
            style: {
              fontSize: '12px', 
              fontWeight: 'normal'
            },
          },
          labels: {
            style: {
              fontSize: '10px',
            },
            formatter: function (val) {
              return val?.toFixed(0)?.toLocaleString();
            }
          },
          tickAmount: 4,
          min: 0, 
          max: maxEnodValue > 100 ?  Math.ceil(maxEnodValue / 100) * 100 : Math.ceil(maxEnodValue / 10) * 10, 
        },
        {
          show: false,
          tickAmount: 4,
          min: 0, 
          max: maxEnodValue > 100 ?  Math.ceil(maxEnodValue / 100) * 100 : Math.ceil(maxEnodValue / 10) * 10, 
        },
        {
          opposite: true, 
          title: {
            text: 'Count of Sector',
            style: {
              fontSize: '12px',
              fontWeight: 'normal'
            },
          },
          labels: {
            style: {
              fontSize: '10px',
            },
            formatter: function (val) {
              return val?.toFixed(0)?.toLocaleString();
            }
          },
          tickAmount: 4,
          min: 0, 
          max: getMaxSector(), 
        }
      ],
      dataLabels: {
        offsetY: -4.5,
        style: {
          fontSize: '9px',
          colors: ['#141313'],
        },
      },
    },
    series: yAxisData
  };

  const getBottomMargin = () => {
    let bottomMargin = '165px'
     
    if(isLegendMinimized) return bottomMargin
    if(iconData.edotco && iconData.operator && iconData.capacity) bottomMargin = '390px'
    else if(iconData.edotco && iconData.operator) bottomMargin ='365px'
    else if(iconData.edotco && iconData.capacity) bottomMargin = '300px'
    else if(iconData.operator && iconData.capacity) bottomMargin = '225px'
    else if(iconData.capacity) bottomMargin = (mapPlacement === 'left')? '155px': '135px'
    else if(iconData.edotco) bottomMargin = '235px'
    
    return bottomMargin
  }


  return (
    <>
      {showChart && (
        <div
          className="chart-container"
          style={{
            position: 'absolute',
            bottom: getBottomMargin(),
            ...chartAlignment,
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            boxShadow: '0px 3px 6px #0000003D',
            padding: '5px',
            zIndex: 1,
            width: expanded ? '478px' : '40px',
            height: expanded ? '205px' : '40px',
            border: '1px solid #707070',
            borderRadius: '10px',
          }}
        >
          <button
            className="custom-button"
            onClick={toggleChart}
          >{buttonIcon}</button>
          <Chart
            options={ChartObj.options}
            series={ChartObj.series}
            type="bar"
            width={expanded ? '448' : '0'}
            height={expanded ? '190' : '0'}
          />
        </div>
      )}
    </>
  );
};

export default CapacityChart;
